import React from "react";
import FilterResult from "./FilterResult";
import Logo from "./Logo";
import MidBanner from "./MidBanner";
import TopMenu from "./TopMenu";

const HeaderBanner = () => {
    return (
        <div className="h_banner">
            <Logo/>
            <MidBanner/>
            <FilterResult/>
            <TopMenu/>
        </div>
    );
};
export default HeaderBanner;
